"use strict";
exports.__esModule = true;
exports.invoiceAPInvoicesToInvoiceSources = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Utility to transform various invoice types into invoice-sources component.
 */
var invoice_sources_1 = require("./invoice-sources");
function invoiceAPInvoicesToInvoiceSources(invoices) {
    if (!invoices || invoices.length === 0) {
        return (0, jsx_runtime_1.jsx)("span", { children: "No code sources available." });
    }
    return ((0, jsx_runtime_1.jsx)(invoice_sources_1.InvoiceSources, { invoices: invoices.map(function (invoice) {
            var _a;
            return ({
                id: invoice.guid,
                type: invoice.type,
                performingProviderName: invoice.performing_provider_name,
                transactions: (_a = invoice.transactions) === null || _a === void 0 ? void 0 : _a.map(function (transaction) {
                    var _a, _b;
                    return ({
                        id: transaction.guid,
                        diagnoses: (_a = transaction.diagnoses) === null || _a === void 0 ? void 0 : _a.map(function (diagnosis) { return ({
                            code: diagnosis.diagnosis_code
                        }); }),
                        modifiers: (_b = transaction.modifiers) === null || _b === void 0 ? void 0 : _b.map(function (modifier) { return ({
                            code: modifier.modifier_code
                        }); }),
                        procedures: [
                            // Amplify will contain 1 procedure
                            {
                                displayTechnicalCodeUnits: !transaction.procedure,
                                procedure: transaction.procedure
                                    ? {
                                        code: transaction.procedure.procedure_code,
                                        units: transaction.procedure.units
                                    }
                                    : null,
                                technicalCode: transaction.technical_code
                                    ? {
                                        code: transaction.technical_code.code,
                                        units: transaction.technical_code.units
                                    }
                                    : null
                            }
                        ]
                    });
                })
            });
        }) }));
}
exports.invoiceAPInvoicesToInvoiceSources = invoiceAPInvoicesToInvoiceSources;
//# sourceMappingURL=invoice-sources-transform.js.map